'use client';

import React, { useEffect } from 'react';

const STRUCTURED_DATA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://retornaAr.com.br/#organization',
      name: 'RetornaAr',
      url: 'https://retornaAr.com.br',
      logo: {
        '@type': 'ImageObject',
        url: 'https://retornaAr.com.br/assets/images/f5eb5313-b619-4891-b33b-45d135a74072-1772573276226.png',
      },
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'contato@retornaAr.com.br',
        contactType: 'customer service',
        availableLanguage: 'Portuguese',
      },
    },
    {
      '@type': 'WebPage',
      '@id': 'https://retornaAr.com.br/#webpage',
      url: 'https://retornaAr.com.br',
      name: 'RetornaAr — Nunca Mais Esqueça um Cliente de AC',
      description: 'Sistema que lembra você quando é hora de entrar em contato com seus clientes de ar-condicionado para a próxima manutenção.',
      inLanguage: 'pt-BR',
    },
    {
      '@type': 'SoftwareApplication',
      name: 'RetornaAr',
      operatingSystem: 'Web',
      applicationCategory: 'BusinessApplication',
      description: 'Sistema que avisa o dono da empresa de ar-condicionado quando é hora de entrar em contato com um cliente para a próxima manutenção preventiva.',
      offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'BRL',
        description: 'Acesso gratuito para as primeiras 10 empresas',
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'O sistema envia mensagens para os meus clientes?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Não. O RetornaAr não envia nenhuma mensagem para os seus clientes. Ele envia o lembrete apenas para você — o dono da empresa. Você é quem decide como e quando entrar em contato com cada cliente.',
          },
        },
        {
          '@type': 'Question',
          name: 'É difícil de usar?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Não. Você cadastra um serviço em menos de 1 minuto: nome do cliente, modelo do AC (opcional) e a periodicidade da manutenção. Se você sabe usar o WhatsApp, você sabe usar o RetornaAr.',
          },
        },
      ],
    },
  ],
};

/** Injeta o JSON-LD no head apenas no client para evitar hydration mismatch. */
export default function StructuredDataScript() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(STRUCTURED_DATA);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
}
